import { layers } from 'app/spacing';
import styled from '@emotion/styled';
import Loader from 'components/Kizen/Loader';

export const ChartLayout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Chart = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  padding-top: 5px;
  margin-left: -15px;
  margin-right: -60px;
  margin-bottom: -10px;
`;

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 0;
  left: -15px;
  right: -15px;
  bottom: -5px;
  padding-top: 0 !important;
  background-color: var(--color-background-white);
  z-index: ${layers.content(10)};

  & > div {
    margin-top: 10%;
    margin-right: 10px;
  }
`;

export const Legend = styled.div`
  display: flex;
  padding-bottom: 3px;
  padding-top: 9px;
  color: var(--color-font-primary);
`;

export const LegendContent = styled.div`
  margin: 0 auto;
  display: flex;
`;

export const LegendEntry = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
`;

export const CircularMarker = styled.div`
  border-radius: 8px;
  width: 8px;
  height: 8px;
  background: ${(props) => props.color || 'var(--color-viz-cat-1-secondary)'};
  margin-right: 5px;
`;

export const DashedMarker = styled.div`
  width: 8px;
  margin-right: 5px;
  display: flex;
  column-gap: 1px;
`;

export const DashedMarkerChild = styled.div`
  width: 2px;
  height: 1px;
  background: var(--color-background-darker);
  padding-top: 1px;
  border-radius: 3px;
`;

export const GradientMarker = styled.div`
  width: 8px;
  height: 8px;
  display: flex;
  column-gap: 1px;
  margin-right: 5px;

  & > div:first-child {
    background-color: var(--color-viz-cat-2-secondary);
  }

  & > div:nth-child(2) {
    background-color: color-mix(
      in srgb,
      var(--color-viz-cat-2-secondary) 27%,
      transparent
    );
  }

  & > div:last-child {
    background-color: color-mix(
      in srgb,
      var(--color-viz-cat-2-secondary) 16%,
      transparent
    );
  }
`;

export const GradientChild = styled.div`
  width: 2px;
  height: 100%;
`;

export const ChartOverlay = styled.div`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 100ms,
    opacity 100ms linear;
  width: 0;
  right: 14px;
  top: 0;
  bottom: 50px;
  background: linear-gradient(
    to top,
    color-mix(in srgb, var(--color-background-white) 100%, transparent),
    color-mix(in srgb, var(--color-background-white) 0%, transparent) 50px
  );
  border-bottom: 1px solid var(--color-border-medium-light);
  pointer-events: none;
`;
